import { useAppStateStore } from '@/features/application'
import { computed } from 'vue'
import { useFactureRoutingService } from '../../detail/facture/useFactureRoutingService'
import { useFavorisStore } from '../../favoris/favorisStore'

export function useRechercheFactureActions() {
  const routingService = useFactureRoutingService()
  const { addFavori } = useFavorisStore()
  const appState = useAppStateStore()

  const readonlyFacture = computed<boolean>(() => {
    return appState.autoriseLecture('Facture') === false
  })

  const readonlyRib = computed<boolean>(() => {
    return appState.autoriseLecture('RIB') === false
  })

  function displayFacture(code: string) {
    routingService.navigateToWithKey(code)
  }

  function redirectSelfeFacture() {
    const a = document.createElement('a')
    try {
      a.href = import.meta.env.VITE_SELFE_FACTURE
      a.target = '_blank'
      document.body.appendChild(a)
    } finally {
      a.click()
      a.remove()
    }
  }

  function redirectSelfeRib() {
    const a = document.createElement('a')
    try {
      a.href = import.meta.env.VITE_SELFE_RIB
      a.target = '_blank'
      document.body.appendChild(a)
    } finally {
      a.click()
      a.remove()
    }
  }

  return { readonlyFacture, readonlyRib, addFavori, displayFacture, redirectSelfeFacture, redirectSelfeRib }
}
